<template>
<div class="tab2">
                <div class="box1">
                  <div class="titleContainer">
                    <div class="title">
                      <div class="icon">
                        <span class="before"></span>
                        <span class="after"></span>
                      </div>
                      <div>新华CN-ESG评价体系介绍</div>
                    </div>
                    <div class="more" @click="handleClickMore('https://baijiahao.baidu.com/s?id=1685321631002972970&wfr=spider&for=pc')">查看更多>></div>
                  </div>
                  <div class="item1Container">
                    <div class="desc">
                      <p class="row">2020中国企业家博鳌论坛上，中国经济信息社发布了“新华CN-ESG评价体系”。新华CN-ESG评价体系在设计理念上注重对接国际标准，使其具有国际可比性，契合中国监管要求的导向与发展阶段，同时聚焦本土化特色ESG议题和中国企业核心问题。在通用指标的基础上，充分考虑行业特性、政府监管处罚与社会舆情，进行指标设置，以期全方位期全方位评价中国企业ESG表现。</p>
                      <p>中国经济信息社依托智库咨询优势，聚合内外部专家资源，重新定义中国特色ESG，打造ESG本土标准，覆盖多方基本合规披露标准、覆盖国际投资者重点关注议题、重新定义中国特色指标，为中国上市公司、金融机构以及区域性可持续发展提供专业服务与技术工具，根据 ESG基本面分析、量化投资、评级提升，风险监控等差异化使用场景，定制化地提供一站式ESG解决方案。</p>
                    </div>
                    <div class="img2-1"></div>

                  </div>
                </div>
                <div class="box2">
                  <div class="title">
                    <div class="icon">
                      <span class="before"></span>
                      <span class="after"></span>
                    </div>
                    <div>新华CN-ESG</div>
                  </div>
                  <div class="desc">
                    新华CN-ESG评价体系系统梳理海内外合规披露标准与核心关注议题，在满足国际可比性的同时，聚焦中国企业ESG 核心问题，契合中国监管要求导向及发展阶段，从环境E、社会S、治理G、行业B四个维度，构建了包含110+二级通用指标、350+数据点，40+可选指标的行业风险与机遇双向衡量，舆情数据实时调整的系统化CN -ESG评级体系。评价体系融入精准扶贫、党建等中国特色议题，同时通过对标国内现有公司治理专业标准和专家访谈的方式优化治理维度，使得指标体系更切合中国实际。
                  </div>
                  <div class="item2Container">
                    <div class="item2Left">
                      <div class="item2Img1"></div>
                      <div class="item2Img2"></div>
                    </div>
                    <div class="item2Right"></div>
                  </div>
                </div>
                <div class="item3Container">
                  <div class="item3Left">
                    <div class="titleContainer3">
                      <div class="title">
                        <div class="icon">
                          <span class="before"></span>
                          <span class="after"></span>
                        </div>
                        <div>新华CN-ESG上市公司优选500跟踪标的</div>
                      </div>
                      <div class="more" @click="handleClickMore('https://baijiahao.baidu.com/s?id=1697644775354818511&wfr=spider&for=pc')">查看更多>></div>
                    </div>
                    <div>
                      2021年4月份，基于新华CN-ESG评价标准体系，中经社研发了“新华CN-ESG上市公司优选500跟踪标的”。研发团队利用AI机器学习模型，对中国A股4000多家上市公司进行了全面评价，评选出ESG综合得分较好的前500家公司。中经社将对优选出的500家上市公司加强ESG风险监测，定期更新评价结果并发布，为满足市场和投资者ESG可持续发展需求不懈努力。
                    </div>
                  </div>
                  <div class="item3Right">

                  </div>
                </div>
                <div class="item4Container">
                  <div class="item4Left">
                  </div>
                  <div class="item4Right">
                    <div class="titleContainer4">
                      <div class="title">
                        <div class="icon">
                          <span class="before"></span>
                          <span class="after"></span>
                        </div>
                        <div>新华CN-ESG优选300指数</div>
                      </div>
                      <div class="more" @click="handleClickMore('https://baijiahao.baidu.com/s?id=1685321631002972970&wfr=spider&for=pc')">查看更多>></div>
                    </div>
                    <div>
                      2021年8月份，基于新华CN-ESG评价标准体系，新华CN-ESG优选300指数(989008)正式发布。该指数以新华500指数样本股作为样本空间，选择ESG评分较高的300只公司股票形成指数，反映A股中可持续发展能力较强的大中市值企业价格水平走势。
                    </div>
                  </div>
                </div>
                <div class="title">
                    <div class="icon">
                      <span class="before"></span>
                      <span class="after"></span>
                    </div>
                    <div>ESG咨询服务</div>
                  </div>
                  <div class="desc4">
                    中经社具备完整的经济信息服务生态，充分发挥智库和传播优势，激励企业加强ESG信息披露，挖掘国内各行业领袖在ESG可持续发展方面的实践案例，强化头部企业的引领作用。中经社为政府机构、金融机构、行业协会及企业提供ESG信息披露/社会责任报告、ESG评价服务、ESG全景发布传播等定制化咨询服务。
                  </div>
                  <div class="item5Container">
                      <div class="item5-1"></div>
                      <div class="item5Right">
                        <div class="item5RightItem">
                          重点服务上市公司。根据监管部门要求，依据企业自身特点量身定制一套完整的ESG报告编制服务流程，选取适用的参考标准，进行尽职调查并采集必要的ESG相关信息和量化数据，编制《ESG信息披露报告》并协助进行公开发布。
                        </div>
                      </div>
                  </div>
                  <div class="item5Container">
                      <div class="item5-2"></div>
                      <div class="item5Right">
                        <div class="item5RightItem">
                          通过引入适合本土的ESG评估指标体系，为企业进行整体ESG评价，从环境保护、社会责任和公司治理等三大方面对企业可持续性进行全方位衡量，评估企业在环境风险体系建设、管理体系建设及社会责任履行等方面的客观表现，形成《企业ESG可持续发展能力评价报告》或《企业社会责任评价报告》，全面展现企业ESG可持续发展水平。
                        </div>
                      </div>
                  </div>
                  <div class="item5Container">
                      <div class="item5-3"></div>
                      <div class="item5Right">
                        <div class="item5RightItem">
                          以企业所在行业（区域）发展研究为切入点，从ESG角度对行业的发展现状、主要问题、发展机遇进行梳理整合，结合企业在行业（区域）的探索及实践，以企业为试点研究对象，联合发布研究报告，打造企业在行业（区域）的发展影响力，彰显企业社会责任，共同编写并发《行业（区域）ESG研究报告》或《行业（区域）社会责任年度报告》等。
                        </div>
                      </div>
                  </div>
                  <div class="item5Container">
                      <div class="item5-4"></div>
                      <div class="item5Right">
                        <div class="item5RightItem">
                          挖掘国内各领域各行业ESG领袖在绿色可持续发展方面的实践案例，凸显绿色低碳先锋的标杆榜样作用，助力ESG绿色治理概念传播推广，鼓励更多企业、机构和企业家参与到ESG绿色治理实践和低碳发展中来，为推进绿色发展理念和生态文明建设承担更多社会责任。
                        </div>
                      </div>
                  </div>
              </div>
</template>
<script>
//import { mapActions } from "vuex";
//import List from "./components/List";
export default {
  data() {
    return {
      
      //activeName: "0",
    };
  },
  components: {
   /*  List, */
  },
  computed: {

  },//
  mounted() {
    /* this.getLeftMenuList().then((data) => {
      this.leftMenus = data;
    }); */
  },
  methods: {
    handleClickMore(router){
      let regHttp = /(http|https):\/\//;
      if (regHttp.test(router)) {
        // let param = "";
        // window.open(router, "", param);
        this.$utils.open(router);
      } else {
        this.$router.push(router);
      }
    }
    /* ...mapActions("dynamicInfo/index", {
      getTabMenuList: "GET_TAB_MENU_LIST",
    }), */
    /* leftSelect(index) {
      let currentMenu = this.leftMenus[index];
      this.classifyCode = currentMenu.code;
    }, */
/*     handleClick(tab, event) {
        console.log(tab, event);
        let code=tab.name;
        console.log(tab.name)
          this.getInfoList(code).then((data)=>{
          console.log(data)
          this.infoList=data.data
        })
        
        
      }  */   
  },
};
</script>
<style lang="scss" scoped>
.Black{
  .tab2{
    
    
    .item2Container{
        
      .item2Img1{
          
        background: url('../../../assets/black_theme/esg-college-tab2-2-1.png') no-repeat;
        background-position: center;
        background-size: contain;
      }
      .item2Img2{
          
          background: url('../../../assets/black_theme/esg-college-tab2-2-2.png') no-repeat;
          background-position: center;
          background-size: cover;

      }
      .item2Right{
          
          background: url('../../../assets/black_theme/esg-college-tab2-2-3.png') no-repeat;
          background-position: center;
          background-size: cover;
        }    
    }
    .item3Container{
      .titleContainer3{
        .more{
          font-size: 12px;
          color: #A1A7AF;
          cursor:pointer;
          &:hover{
            color: #008BCE;
          }
        }
      }
    }
    .item4Container{
      .titleContainer4{
        .more{
          font-size: 12px;
          color: #A1A7AF;
          cursor:pointer;
          &:hover{
            color: #008BCE;
          }
        }
      }
    }
    .item5Container {
      .item5Right{
        border: 1px solid #223750;
        background-color: #011A36;
        
        
      }
      
    }
    .desc4{
        color: var(--font_01);
    }
  }
}
    .tab2{
      width: 100%;
     /*  height: 438px; */
      margin: 0 auto;
      .title{
          width: 1100px;
          margin: 0 auto;
          display: flex;
          margin-top: 10px;
          margin-bottom: 20px;
          padding-left: 2px;
          font-weight: bold;
          font-size: 16px;
          color: var(--font_01);
        .icon{
          position: relative;
          margin-right: 10px;
          margin-top: 4px;
          .before{
            position: absolute;
            top: 2px;
            left: -2px;
            width: 10px;
            height: 10px;
            background-color: #008BCE;
          }
          .after{
            display: block;
            width: 10px;
            height: 10px;
            background-color: #008BCE;
            opacity: 0.19;
          }

        }
      }
      .desc{
        width: 1100px;
        /* margin: 0 auto; */
        line-height: 22px;
        color: var(--font_01);
      }
      
      .titleContainer{
        width: 1100px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .title{
          display: flex;
          margin-top: 10px;
          margin-bottom: 20px;
          padding-left: 2px;
          font-weight: bold;
          font-size: 16px;
          .icon{
            position: relative;
            margin-right: 10px;
            margin-top: 4px;
            .before{
              position: absolute;
              top: 2px;
              left: -2px;
              width: 10px;
              height: 10px;
              background-color: #008BCE;
            }
            .after{
              display: block;
              width: 10px;
              height: 10px;
              background-color: #008BCE;
              opacity: 0.19;
            }

          }
        }
        .more{
          padding-top: 10px;
          cursor: pointer;
          font-size: 12px;
          color: #A1A7AF;
          white-space: nowrap;
          &:hover{
            color: #008BCE;
          }
        }
      }
      .item2Container{
        width: 1100px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding-left: 40px;
        margin-bottom: 100px;
        margin-top: 60px;
        .item2Img1{
          width: 572px;
          height: 155px;
          background: url('../../../assets/white_theme/esg-college-tab2-2-1.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .item2Img2{
          width: 572px;
          height: 155px;
          background: url('../../../assets/white_theme/esg-college-tab2-2-2.png') no-repeat;
          background-position: center;
          background-size: cover;

        }
        .item2Right{
          width: 287px;
          height: 280px;
          margin-top: 30px;
          margin-right: 60px;
          background: url('../../../assets/white_theme/esg-college-tab2-2-3.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
      }
      .item3Container{
        width: 1100px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        color: var(--font_01);
        .titleContainer3{
       
        display: flex;
        justify-content: space-between;
          .more{
            white-space: nowrap;
            font-size: 12px;
            color: #A1A7AF;
            cursor:pointer;
            white-space: nowrap;
            &:hover{
              color: #008BCE;
            }
          }
        }
        .item3Left{
          width: 660px;
          
          /* display: flex;
          justify-content: space-between; */
        }
        .item3Right{
          width: 300px;
          height: 170px;
          background: url('../../../assets/white_theme/esg-college-tab2-3.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
      }
      .item4Container{
        width: 1100px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        margin-top: 80px;
        margin-bottom: 120px;
        color: var(--font_01);
        .titleContainer4{
        
          display: flex;
          justify-content: space-between;
          .more{
            white-space: nowrap;
            font-size: 12px;
            color: #A1A7AF;
            cursor:pointer;
            &:hover{
              color: #008BCE;
            }
          }
        }
        .item4Left{
          width: 300px;
          height: 170px;
          background: url('../../../assets/white_theme/esg-college-tab2-4.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .item4Right{
          width: 660px;
          
          /* display: flex;
          justify-content: space-between; */
        }
      }
      .desc4{
              width: 1100px;
              margin: 0 auto;
              line-height: 22px;
        }
      .item5Container{
        width: 1100px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        width: 890px;
        height: 130px;
        margin: 30px auto;
        .item5-1{
          width: 223px;
          height: 131px;
          background: url('../../../assets/white_theme/esg-college-tab2-5-1.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .item5-2{
          width: 223px;
          height: 131px;
          background: url('../../../assets/white_theme/esg-college-tab2-5-2.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .item5-3{
          width: 223px;
          height: 131px;
          background: url('../../../assets/white_theme/esg-college-tab2-5-3.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .item5-4{
          width: 223px;
          height: 131px;
          background: url('../../../assets/white_theme/esg-college-tab2-5-4.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .item5Right{
          display: flex;
          align-items: center;
          justify-content: space-around;
          width: 667px;
          padding: 36px;
          background-color: #fff;
          .item5RightItem{
            flex: 0 1 600px;
            color: var(--xhcj-sub-font_02);
          }
        }
      }
      
/*       .img1-1{
        width: 840px;
        height: 185px;
        margin: 0 auto;
        background: url('../../../assets/white_theme/esg-college-tab1-1.png') no-repeat;
        background-position: center;
        background-size: cover;
      } */
      .item1Container{
        width: 1100px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        margin-bottom: 80px;
        .desc{
          width: 582px;
          height: 210px;
          .row{
            margin-bottom: 10px;
          }

        }
        .img2-1{
          width: 371px;
          height: 209px;
          background: url('../../../assets/white_theme/esg-college-tab2-1.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
      }
      .box2{
        .desc{
          margin: 0 auto;
        }
      }

    }
    

</style>
